import { GetExtBrowsingCapsArgs, GetExtBrowsingCapsQuery, GetNodesQuery, Node, NodeArgs } from '../../autogenerated/ZoomBridge';
import ErrorHandler from '../../error/ErrorHandler';
import Authenticator from '../../protocol/Authenticator';
import { ThemeSetup } from '../../themes/ThemeSetup';
import { BROWSE_EXT_CONSTANT } from '../../util/Constants';

export class BrowseExtUtil  {
  static isFolder = (type: string) => {
    return type === BROWSE_EXT_CONSTANT.NODE_TYPE.FOLDER ? true : false;
  }

  static isFile = (type: string) => {
    return type === BROWSE_EXT_CONSTANT.NODE_TYPE.FILE ? true : false;
  };

  
static isRootNodeKey = (key: string) => {
  return key === BROWSE_EXT_CONSTANT.KEYS.ROOT ? true : false;
};

static getLabel = (key: string, type: string) => {
  let keys = [],
    label = '';
  if (key && key.length) {
    keys = key.split(BROWSE_EXT_CONSTANT.KEYS.ROOT);
  }
  if (keys && BrowseExtUtil.isFile(type)) {
    label = keys[keys.length - 1];
  } else {
    label = keys[keys.length - 2];
  }
  return key ? label : null;
};

static getIcon = (show = false) => {
  return show ? ThemeSetup.getImageURL('refactor/icons_open_folder.svg') : ThemeSetup.getImageURL('refactor/icons_folder.svg');
};

static getFileIcon = () => {
  return ThemeSetup.getImageURL('plane-file-icon.svg');
};

static getIngestIcon = () => {
  return 'images/ingested_from_cloud.svg';
};

static isIngested = (status: string) => {
  return status === BROWSE_EXT_CONSTANT.STATUS.INGESTED ? true : false;
};

static getLastChildNodeKey = (node: Node) => {
  const childNodes: Array<Node> = node.getChildNodes();
  return childNodes.length ? childNodes[childNodes.length - 1].getKey() : '';
};

static isNoChilds = (node: Node) => {
  return node.getChildNodes().length ? false : true;
};

static fetchBuckets = () => {
  const extBrowsingCapsQuery = new GetExtBrowsingCapsQuery();
  const extBrowsingCapsArgs = new GetExtBrowsingCapsArgs();
  extBrowsingCapsArgs.setUserName(Authenticator.AUTH_DATA.username);
  extBrowsingCapsQuery.message = extBrowsingCapsArgs;
  return extBrowsingCapsQuery.run()
};

static fetchRootNode = (
  bucketName: string,
  parent_key: string,
  setNode: function,
  setLoading: function,
  refresh: boolean = false,
  startAfter: string = null
) => {
  if (!bucketName) return;
  const getNodesQuery: GetNodesQuery = new GetNodesQuery();
  const nodeArgs: NodeArgs = new NodeArgs();
  nodeArgs.setStorageType('S3');
  nodeArgs.setStorageName(bucketName);
  nodeArgs.setKey(parent_key);
  nodeArgs.setRefresh(refresh);
  nodeArgs.setStartAfter(startAfter);
  getNodesQuery.message = nodeArgs;
  setLoading(true);
  getNodesQuery
    .run()
    .then((res: Node) => {
      if(res.getKey()) {
        setNode(res);
      } else {
        setLoading(false);
      }
      
    })
    .catch((err) => {
      setLoading(false);
      ErrorHandler.handleError(err);
    });
};

}